import { LogoutOutlined } from '@ant-design/icons';
import { Avatar, Dropdown } from 'antd';
import { useApp } from '../../store/appStores';
import { t } from '../LangProvider';

export const ProfileButton = () => {
  const profile = useApp((s) => s.profile);

  const handleLogout = () => {
    window.localStorage.removeItem('token');

    window.location.href = '/';
  };

  if (!profile) return null;

  return (
    <Dropdown
      menu={{
        items: [
          { label: t('Cerrar sesión'), icon: <LogoutOutlined />, onClick: handleLogout },
        ],
      }}
    >
      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
        <div style={{ color: 'white' }}>{profile?.username}</div>
        <Avatar src={profile?.picture?.url ?? '/img/logo.png'} />
      </div>
    </Dropdown>
  );
};
